import React, {useState, useEffect} from 'react'
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CompareIcon from '@mui/icons-material/Compare';
import { actionTypes, useStateValue } from "./../../store";
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
const BtnCompare = ({ pid, pname, btntype, pimage, entryText, catid }) => {
    const [{ token, huid }, dispatch] = useStateValue();
    const [compe, setCompe] = useState(false);

    const handleCompareProduct = () => {
        var existingEntries = JSON.parse(localStorage.getItem("allEntries"));
        if (existingEntries == null) existingEntries = [];
        var entry = {
            "id": pid,
            "title": pname,
            "text": entryText,
            "img": pimage,
            "catid": catid,
        };
        var dataMatch = existingEntries?.map(t => t.id);
        var dataMatchCateID = existingEntries?.map(t => t.catid);
       
        if (existingEntries.length > 3) {
            dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
            dispatch({ type: actionTypes.SET_MSGALERTDATA, value: 'You have already selected 4 products' });
            dispatch({ type: actionTypes.SET_MSGALERT, value: true });
        } else if (dataMatch.includes(pid)) {
            dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
            dispatch({ type: actionTypes.SET_MSGALERTDATA, value: `${pname} alreay in comparison list` });
            dispatch({ type: actionTypes.SET_MSGALERT, value: true });
        } else if (existingEntries.length > 0 && !dataMatchCateID.includes(catid)) {
            dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
            dispatch({ type: actionTypes.SET_MSGALERTDATA, value: `Only select same category product` });
            dispatch({ type: actionTypes.SET_MSGALERT, value: true });
        } else {
            existingEntries.push(entry);
            setCompe(true);
            localStorage.setItem("allEntries", JSON.stringify(existingEntries));
            dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'success' });
            dispatch({ type: actionTypes.SET_MSGALERTDATA, value: `You added ${pname} to the comparison list` });
            dispatch({ type: actionTypes.SET_MSGALERT, value: true });
            dispatch({ type: actionTypes.SET_COMPAREITEMCOUNT, value: existingEntries.length });
        }
    }

    const checkAlredyComList = () => {
        var existingEntries = JSON.parse(localStorage.getItem("allEntries"));
        var dataMatch = existingEntries?.map(t => t.id);
        if(dataMatch?.includes(pid)){
            setCompe(true);
        }
    }
    useEffect(() => {
        checkAlredyComList();
    }, );
   
    return (
        <>
        {btntype=='icon'?<>
        <IconButton size="small" className='ms-3 txtlgeay bgsgray' edge="end" onClick={() => handleCompareProduct(pid)} > <CompareArrowsIcon fontSize="small"  color={compe ? 'error' : ''} /></IconButton>
        </>:<>
        <Button variant="outlined" onClick={() => handleCompareProduct(pid)} color="primary" startIcon={<CompareArrowsIcon className='' />} type="submit" size="small" className='w-100  text-capitalize'>Add compare</Button>
        </>}
        </>
    )
}

export default BtnCompare